/**
 * Agent identity, status indicators, action colors
 */

// Non-canon brand colors only. Canon agents' accent lives in agents.yaml →
// ROSTER (see lib/agent-accent); roster ids must NOT be duplicated here.
export const agent = {
  scout: "#22d3ee",
  gemini: "#facc15",
  trend: "#C8A364",
  // Feature tabs
  cast: "#9d7bff",
  kit: "#5ee6b8",
  assets: "#d8ff38",
  cli: "#7c93ff",
  // SwipeShell decorative tabs — one bespoke accent per screen feature
  domains: "#34d399",
  graph: "#8b5cf6",
  fugu: "#38bdf8",
  git: "#f59e0b",
  instructions: "#a78bfa",
} as const;

// Agent state indicators
export const status = {
  busy: "#3dd68c",
  idle: "#5e6ad2",
  stale: "#fbbf24",
  dead: "#f87171",
  stopping: "#f0bf00",
  online: "#34d399",
  offline: "#f87171",
} as const;

// Approve/reject/destructive
export const action = {
  approve: "#22c55e",
  reject: "#ef4444",
  destructive: "#ff3b30",
  destructiveBg: "rgba(255,59,48,0.2)",
} as const;
